import { Routes } from '@angular/router';
import { authenticationGuard, ErrorPagesComponent } from '@maersk-global/angular-shared-library';
import { AuthLoginComponent } from './core/components/auth/auth-login.component';
import { FullLayoutComponent } from './shared/components/layouts/full-layout/full-layout.component';
import { UserDataResolver } from './core/resolvers/user-data.resolver';
import { UserConfigDataResolver } from './core/resolvers/user-config-data.resolver';
import { userInitGuard } from './core/guards/user-init.guard';
import { termsAcceptanceGuard } from './core/guards/terms-acceptance.guard';
import { adminFeatureAccessGuard } from './core/guards/admin-feature-access.guard';
import { globalAdminGuard } from './core/guards/global-admin.guard';

export const routes: Routes = [
  {
    path: 'oauth2/login',
    component: AuthLoginComponent
  },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorPagesComponent,
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./modules/terms/terms-page.component').then(
        (m) => m.TermsPageComponent
      ),
    resolve: {
      resolvedData: UserDataResolver
    },
    canActivate: [authenticationGuard, userInitGuard]
  },
  { 
    path: '',
    component: FullLayoutComponent,
    resolve: {
      resolvedData: UserDataResolver
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'shipments',
        loadComponent: () =>
          import('./modules/shipments/dryiot-shipments/dryiot-shipments.component').then(
            (m) => m.DryIotShipmentsComponent
          )
      },
      {
        path: 'shipment-tracking',
        loadComponent: () =>
          import('./modules/shipments/dryiot-shipment-tracking/dryiot-shipment-tracking.component').then(
            (m) => m.DryIotShipmentTrackingComponent
          ),
        resolve: {
          resolvedData: UserConfigDataResolver
        },
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          )
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./modules/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
        canActivate: [adminFeatureAccessGuard]
      },
      {
        path: 'fileupload',
        loadComponent: () =>
          import('./modules/file-upload/inventory-file-upload/inventory-file-upload.component').then(
            (m) => m.InventoryFileUploadComponent
          ),
        canActivate: [globalAdminGuard]
      }
    ],
    canActivate: [authenticationGuard, userInitGuard, termsAcceptanceGuard]
  }

];
